import InviteUsers from '@/components/InviteUsers/index'
import PageWithBackButton from '@/components/PageWithBackButton/index'

export default {
  name: 'InviteFriends',
  components: {
    InviteUsers,
    PageWithBackButton
  },
  data: () => ({
    groupId: ''
  }),
  created() {
    this.groupId = this.$route.params.groupId
  }
}
